import AddCompanyForm from '@/components/features/Companies/forms/AddCompanyForm';
import { useTranslations } from '@/hooks/useTranslations';
import CreateLayout from '@/layouts/create-layout';
import { type BreadcrumbItem } from '@/types';
import { Head } from '@inertiajs/react';

export default function CreateCompany() {
    const { t } = useTranslations();

    const breadcrumbs: BreadcrumbItem[] = [
        {
            title: t('companies.create.breadcrumbs.dashboard', 'Dashboard'),
            href: '/dashboard',
        },
        {
            title: t('companies.create.breadcrumbs.companies', 'Companies'),
            href: '/companies',
        },
        {
            title: t('companies.create.breadcrumbs.create', 'Create'),
            href: '/companies/create',
        },
    ];

    return (
        <CreateLayout
            breadcrumbs={breadcrumbs}
            title={t('companies.create.heading', 'Create Company')}
            subtitle={t('companies.create.subheading', 'Add a new company to your system')}
        >
            <Head title={t('companies.create.title', 'Create Company')} />
            <AddCompanyForm />
        </CreateLayout>
    );
}
